module.exports = __webpack_public_path__ + "img/ic-tiktok.4b20a09a.svg";